import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  Edit as IconEdit,
  LocalGasStationOutlined as FuelIcon,
  PaymentOutlined as PaymentIcon,
  ReceiptLongOutlined as ReceiptIcon,
  BuildOutlined as RepairIcon,
} from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";

import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";
import { REEFER } from "common/config";

import { ApiMasters } from "apihandlers//masters/masters";
import { ApiIndents } from "apihandlers//indent";
import { ApiGeography } from "apihandlers//geography";
import ChkBox from "components/Custom/ChkBox";
import FuelForm from "../Fuel/FuelForm";
import TripPaymentForm from "../TripPayment/TripPaymentForm";
import TripReceiptForm from "../TripReceipt/TripReceiptForm";
import RepairForm from "../Repair/RepairForm";

const ApiMastersHandler = new ApiMasters();
const ApiIndentHandler = new ApiIndents();
const ApiGeographyHandler = new ApiGeography();

const BillStatus = (props: any) => {
  const { setDashMenu } = props;

  const tempIdRef: any = useRef();
  const loadingPointIdRef: any = useRef();
  const unloadingPointIdRef: any = useRef();
  const vehicleIdRef: any = useRef();
  const customerIdRef: any = useRef();
  const brokerIdRef: any = useRef();
  const driversRef: any = useRef();
  const drivers2Ref: any = useRef();

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [loadingPoints, setLoadingPoints] = useState<any>(null);
  const [unLoadingPoints, setUnLoadingPoints] = useState<any>(null);
  const [vehicles, setVehicles] = useState<any>(null);
  const [customers, setCustomers] = useState<any>(null);
  const [tempratures, setTempratures] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [driverNames, setDriverNames] = useState<any>([]);
  const [driver2Names, setDriver2Names] = useState<any>([]);
  const [selectedLoadPoints, setSelectedLoadPoints] = useState<any>();
  const [getAllPoints, setGetAllPoints] = useState<boolean>(false);
  const [selectedUnLoadPoints, setSelectedUnLoadPoints] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any>({});
  const [fuelEntryDialog, setFuelEntryDialog] = useState<boolean>(false);
  const [paymentEntryDialog, setPaymentEntryDialog] = useState<boolean>(false);
  const [receiptEntryDialog, setReceiptEntryDialog] = useState<boolean>(false);
  const [repairtEntryDialog, setRepairEntryDialog] = useState<boolean>(false);

  useEffect(() => {
    if (loading) {
      getVehicles();
      // getTempRanges();
    }
  }, [loading]);

  const getVehicles = () => {
    const args = {
      activeStatus: "true",
      shortMode: true,
    };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.vehicleNumber,
          };
        });
        setVehicles(list);
        getAreas();
      }
    });
  };

  const getAreas = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setLoadingPoints(list);
        setUnLoadingPoints(list);
        getCustomers();
      }
    });
  };

  const getCustomers = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getTransporters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.organizationName,
          };
        });
        setCustomers(list);
        getTempRanges();
      }
    });
  };

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      fromDate: DateFunctions.getDate("thisyear", "from", FORMATS.SQL_DATE),
      toDate: DateFunctions.getDate("thisyear", "to", FORMATS.SQL_DATE),
      billingStatus: "false",
    };
    ApiIndentHandler.getTrips(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };

  const getTripLoadUnloads = (indentId) => {
    const args = { indentId, activeStatus: "true", web: true };
    ApiIndentHandler.getLoadUnloadPoints(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        setSelectedLoadPoints(response.loadPoints);
        setSelectedUnLoadPoints(response.unloadPoints);
      }
    });
  };

  const getTempRanges = () => {
    const args = {
      minResponse: true,
    };
    ApiMastersHandler.getTempRanges(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.tempName,
          };
        });
        setTempratures(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setSelectedLoadPoints(null);
    setSelectedUnLoadPoints(null);
    getTripLoadUnloads(row.id);
  };

  const onFuelEntry = (row: any) => {
    setSelectedRow(row);
    setFuelEntryDialog(true);
  };
  const onRepairEntry = (row: any) => {
    setSelectedRow(row);
    setRepairEntryDialog(true);
  };
  const onPaymentEntry = (row: any) => {
    setSelectedRow(row);
    setPaymentEntryDialog(true);
  };

  const onReceiptEntry = (row: any) => {
    setSelectedRow(row);
    setReceiptEntryDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "indentNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_NO,
      width: "15%",
    },
    {
      key: "indReceiptDate",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_DATE,
      width: "10%",
      type: "text",
    },
    {
      key: "fromLoc",
      editable: false,
      sortable: true,
      searchable: true,
      name: "From",
      width: "10%",
      type: "text",
    },
    {
      key: "toLoc",
      editable: false,
      sortable: true,
      searchable: true,
      name: "To",
      width: "10%",
      type: "text",
    },
    {
      key: "vehicleNo",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "10%",
      type: "text",
    },
    {
      key: "driverName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_NAME,
      width: "10%",
    },
    {
      key: "driverBalance",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_BALANCE,
      width: "10%",
    },
    {
      key: "status",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.STATUS,
      width: "10%",
      type: "dropdown",
      filters: [
        {
          id: "created",
          name: "CREATED",
        },
        {
          id: "assigned",
          name: "ASSIGNED",
        },
        {
          id: "completed",
          name: "COMPLETED",
        },
      ],
    },
    {
      key: "indentGroup",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.GROUP,
      width: "10%",
      type: "text",
    },
    {
      key: "referenceNo",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.REFERENCE,
      width: "10%",
      type: "text",
    },
    {
      key: "activeStatusText",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "5%",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "15%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.FUEL} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onFuelEntry(params.row)}
            >
              <FuelIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.REPAIR_ICON} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onRepairEntry(params.row)}
            >
              <RepairIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.PAYMENT_ICON} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onPaymentEntry(params.row)}
            >
              <PaymentIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.RECEIPT_ICON} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onReceiptEntry(params.row)}
            >
              <ReceiptIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRecord = () => {
    const referenceNo = (
      document.getElementById("referenceNo") as HTMLInputElement
    ).value.trim();

    const billAmount = (
      document.getElementById("billAmount") as HTMLInputElement
    ).value.trim();
    const billDate = (
      document.getElementById("billDate") as HTMLInputElement
    ).value.trim();
    const closedDt = (
      document.getElementById("closedDt") as HTMLInputElement
    ).value.trim();
    const billNumber = (
      document.getElementById("billNumber") as HTMLInputElement
    ).value.trim();
    const bill = document.querySelector(
      'input[name="billStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = bill ? bill.value : "";

    // Validations
    // if (!billDate) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!billNumber) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!billAmount) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    let errors = [];
    if (billDate == "") {
      errors.push({
        id: "billDate",
        msg:
          "<span class='bold'>" +
          LABELS.BILL_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!billNumber) {
      errors.push({
        id: "billNumber",
        msg:
          "<span class='bold'>" +
          LABELS.BILL_NO +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (closedDt == "") {
      errors.push({
        id: "closedDt",
        msg:
          "<span class='bold'>" +
          LABELS.CLOSE_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!billAmount) {
      errors.push({
        id: "billAmount",
        msg:
          "<span class='bold'>" +
          LABELS.BILL_AMOUNT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!bill) {
      errors.push({
        id: "billStatus",
        msg:
          "<span class='bold'>" +
          LABELS.BILL_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      billDate,
      closedDt,
      billNumber,
      billAmount: Number(billAmount),
      billStatus: Boolean(selectBtnValue),
    };

    console.log("manage", args);
    setIsSubmit(true);
    ApiIndentHandler.manageIndentBillDetails(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  let frightModes = [
    {
      id: "freightTypeToPay",
      value: "TOPAY",
      label: "TO PAY",
      checked: selectedRow.id ? selectedRow.freightType === "TOPAY" : false,
      disabled: false,
    },
    {
      id: "freightTypePaid",
      value: "PAID",
      label: "PAID",
      checked: selectedRow.id ? selectedRow.freightType === "PAID" : false,
      disabled: false,
    },
    {
      id: "freightTypeTbb",
      value: "TBB",
      label: "TBB",
      checked: selectedRow.id ? selectedRow.freightType === "TBB" : false,
      disabled: false,
    },
  ];
  frightModes = frightModes.filter((f) => {
    return f.value === selectedRow.freightType;
  });

  let indModes = [
    {
      id: "indModeMobile",
      value: "Mobile",
      label: "MOBILE",
      checked: selectedRow.id ? selectedRow.indMode === "Mobile" : false,
      disabled: false,
    },
    {
      id: "indModePhone",
      value: "Phone",
      label: "PHONE",
      checked: selectedRow.id ? selectedRow.indMode === "Phone" : false,
      disabled: false,
    },
    {
      id: "indModeEmail",
      value: "Email",
      label: "EMAIL",
      checked: selectedRow.id ? selectedRow.indMode === "Email" : false,
      disabled: false,
    },
    {
      id: "indModeWhatsapp",
      value: "Whatsapp",
      label: "WHATSAPP",
      checked: selectedRow.id ? selectedRow.indMode === "Whatsapp" : false,
      disabled: false,
    },
    {
      id: "indModeMessage",
      value: "Message",
      label: "MESSAGE",
      checked: selectedRow.id ? selectedRow.indMode === "Message" : false,
      disabled: false,
    },
  ];
  indModes = indModes.filter((f) => {
    return f.value === selectedRow.indMode;
  });

  let trips = [
    {
      id: "ldTypeRevenue",
      value: "RevenueTrip",
      label: "REVENUE TRIP",
      checked: selectedRow.id ? selectedRow.ldType === "RevenueTrip" : false,
      disabled: false,
    },
    {
      id: "ldTypeEmpty",
      value: "EmptyTrip",
      label: "EMPTY TRIP",
      checked: selectedRow.id ? selectedRow.ldType === "EmptyTrip" : false,
      disabled: false,
    },
  ];
  trips = trips.filter((f) => {
    return f.value === selectedRow.ldType;
  });

  let Status = [
    {
      id: "activeStatusYes",
      value: "true",
      label: LABELS.ACTIVE,
      checked: selectedRow.id ? selectedRow.activeStatus === true : true,
      disabled: false,
    },
    {
      id: "activeStatusNo",
      value: "false",
      label: LABELS.INACTIVE,
      checked: selectedRow.id ? selectedRow.activeStatus === false : false,
      disabled: false,
    },
  ];
  Status = Status.filter((f) => {
    return f.value === selectedRow.activeStatus;
  });

  console.log("customers:", customers, selectedRow, selectedLoadPoints);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTIONS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.BILL_STATUS}</li>
        </ul>
        <h4>{TITLES.BILL_STATUS}</h4>
        <p className="SubTitles">{SUB_TITLES.BILL_STATUS}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.BILL_STATUS}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.BILL_STATUS}
            onReload={reloadGrid}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.BILL_STATUS + " : " + selectedRow.indentNo
              : "Add New " + LABELS.BILL_STATUS
          }
          open={true}
          size={"lg"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          {selectedLoadPoints && selectedUnLoadPoints ? (
            <>
              <div className="flexColumn">
                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.FREIGHT_AND_INDENT_DETAILS}
                  </legend>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"indContact"}
                        label={LABELS.INDENT_CONTACT}
                        defaultValue={selectedRow.indContact}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"indReceiptDate"}
                        label={LABELS.INDENT_DATE}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.indReceiptDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.indReceiptDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        disabled={true}
                      />
                    </div>{" "}
                    <div className="formGroup width30 ">
                      <TxtRow
                        id={"freight"}
                        label={LABELS.FRIGHT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.freight).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>
                  </div>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"referenceNo"}
                        label={LABELS.BILLING_LOCATION}
                        defaultValue={selectedRow.referenceNo}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.FREIGHT_MODE}</label>
                      <RadioBtn
                        list={frightModes}
                        row={true}
                        name={"freightType"}
                        disabled={true}
                      />
                    </div>
                    {REEFER ? (
                      <div className="formGroup width30">
                        <label>{LABELS.TEMP_RANGE}</label>
                        <AutoComplete
                          list={tempratures}
                          childRef={tempIdRef}
                          defaultValue={
                            selectedRow.temprangeId
                              ? {
                                  id: selectedRow.temprangeId,
                                  label: selectedRow.tempRangeName,
                                }
                              : null
                          }
                          disabled={true}
                        />
                      </div>
                    ) : (
                      <div className="formGroup width30"></div>
                    )}
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <label>{LABELS.TRIP_CAT}</label>
                      <RadioBtn
                        list={trips}
                        row={true}
                        name={"ldType"}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.INDENT_MODE}</label>
                      <RadioBtn
                        list={indModes}
                        row={true}
                        name={"indMode"}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <ChkBox
                        id="roundTrip"
                        text={LABELS.ROUND_TRIP}
                        style={{ fontWeight: "600" }}
                        disabled={true}
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.INITIAL_TRIP_DATA}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30 ">
                      <label>{LABELS.VEHICLE_NO}</label>
                      <AutoComplete
                        list={vehicles}
                        childRef={vehicleIdRef}
                        defaultValue={
                          selectedRow.vehicleId
                            ? {
                                id: selectedRow.vehicleId,
                                label: selectedRow.vehicleNo,
                              }
                            : null
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.DRIVER_NAME}</label>
                      <AutoComplete
                        list={driverNames}
                        childRef={driversRef}
                        defaultValue={
                          selectedRow.driverId
                            ? {
                                id: selectedRow.driverId,
                                label: selectedRow.driverName,
                              }
                            : null
                        }
                        onChange={(e, v) => {}}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.DRIVER_2_NAME}</label>
                      <AutoComplete
                        list={driverNames}
                        childRef={drivers2Ref}
                        defaultValue={
                          selectedRow.driver2Id
                            ? {
                                id: selectedRow.driver2Id,
                                label: selectedRow.driver2Name,
                              }
                            : null
                        }
                        onChange={(e, v) => {}}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30 ">
                      <label>{LABELS.CUSTOMER}</label>
                      <AutoComplete
                        list={customers}
                        childRef={customerIdRef}
                        defaultValue={
                          selectedRow.id
                            ? {
                                id: selectedRow.transporterId,
                                label: selectedRow.transporterName,
                              }
                            : null
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.BROKER}</label>
                      <AutoComplete
                        list={customers}
                        childRef={brokerIdRef}
                        defaultValue={
                          selectedRow.brokerId
                            ? {
                                id: selectedRow.brokerId,
                                label: selectedRow.brokerName,
                              }
                            : null
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"ldDate"}
                        label={LABELS.LOADING_DATE}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.ldDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.ldDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"odometerOpen"}
                        label={LABELS.OPENING_KM}
                        type={"number"}
                        defaultValue={selectedRow.odometerOpen}
                        disabled={true}
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.ROUTE_DETAILS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width45">
                      <div className="flexRowJustify ">
                        <label>{LABELS.LOADING_PT}</label>
                        <Btn
                          text={LABELS.SHOW_ALL_POINTS}
                          bgColor={"#e9e9e9"}
                          color={"#3f3f3f"}
                          onClick={(prevGetAllPoints) => {
                            setGetAllPoints(
                              (prevGetAllPoints) => !prevGetAllPoints
                            );
                          }}
                        />
                      </div>
                      {selectedLoadPoints && (
                        <AutoComplete
                          list={getAllPoints ? unLoadingPoints : loadingPoints}
                          childRef={loadingPointIdRef}
                          multiple={true}
                          defaultValue={
                            selectedRow.id ? selectedLoadPoints : []
                          }
                          disabled={true}
                        />
                      )}
                    </div>
                    <div className="formGroup width45 ">
                      <label>{LABELS.UNLOADING_PT}</label>
                      {selectedUnLoadPoints && (
                        <AutoComplete
                          list={unLoadingPoints}
                          childRef={unloadingPointIdRef}
                          multiple={true}
                          defaultValue={
                            selectedRow.id ? selectedUnLoadPoints : []
                          }
                          disabled={true}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width45">
                      <TxtRow
                        id={"product"}
                        label={LABELS.PRODUCT}
                        defaultValue={selectedRow.product}
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width45">
                      <TxtRow
                        id={"totCrates"}
                        label={LABELS.ORDERED_QTY}
                        type={"number"}
                        defaultValue={selectedRow.totCrates}
                        disabled={true}
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.LOAD_WEIGHTS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"grossWt"}
                        label={LABELS.GROSS_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.grossWt).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>

                    <div className="formGroup width30">
                      <TxtRow
                        id={"tareWt"}
                        label={LABELS.TARE_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.tareWt).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"weight"}
                        label={LABELS.NET_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.weight).toString()
                            : ""
                        }
                        disabled={true}
                      />
                    </div>
                  </div>

                  <div className="flexRowJustify">
                    <div className="formGroup width30 red">
                      <TxtRow
                        id={"billDate"}
                        label={LABELS.BILL_DATE}
                        required={true}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.billDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.billDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                      />
                    </div>
                    <div className="formGroup width30 red">
                      <TxtRow
                        id={"billNumber"}
                        label={LABELS.BILL_NO}
                        required={true}
                        type={"number"}
                        defaultValue={selectedRow.billNumber}
                      />
                    </div>
                    <div className="formGroup width30 red">
                      <TxtRow
                        id={"closedDt"}
                        label={LABELS.CLOSE_DATE}
                        required={true}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.closedDt
                            ? DateFunctions.getFormatedDate(
                                selectedRow.closedDt,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.DELIVERY_DETAILS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"deliveredCrates"}
                        label={LABELS.DELIVERED_QTY}
                        type={"number"}
                        defaultValue={selectedRow.deliveredCrates}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"odometerClose"}
                        label={LABELS.CLOSING_KM}
                        type={"number"}
                        defaultValue={selectedRow.odometerClose}
                      />
                    </div>
                    <div className="formGroup width30"></div>
                  </div>
                </fieldset>

                <div
                  className="flexRowJustify"
                  style={{ alignItems: "center" }}
                >
                  <div className="formGroup width30 ">
                    <label>{LABELS.ACTIVE_STATUS}</label>
                    <RadioBtn
                      list={[
                        {
                          id: "activeYes",
                          value: "true",
                          label: LABELS.ACTIVE,
                          checked: selectedRow.id
                            ? selectedRow.activeStatus === true
                            : true,
                          disabled: false,
                        },
                        {
                          id: "activeNo",
                          value: "false",
                          label: LABELS.INACTIVE,
                          checked: selectedRow.id
                            ? selectedRow.activeStatus === false
                            : false,
                          disabled: false,
                        },
                      ]}
                      row={true}
                      name={"activeStatus"}
                      disabled={true}
                    />
                  </div>
                  <div className="formGroup width30 red">
                    <TxtRow
                      id={"billAmount"}
                      label={LABELS.BILL_AMOUNT}
                      type={"number"}
                      defaultValue={
                        selectedRow.id
                          ? Number(selectedRow.billAmount).toString()
                          : ""
                      }
                      required={true}
                    />
                  </div>
                  <div className="formGroup width30 red">
                    <label>
                      {LABELS.BILL_STATUS} {<span>*</span>}
                    </label>{" "}
                    <RadioBtn
                      list={[
                        {
                          id: "billYes",
                          value: "true",
                          label: LABELS.YES,
                          checked: selectedRow.id
                            ? selectedRow.billStatus === true
                            : true,
                          disabled: false,
                        },
                        {
                          id: "billNo",
                          value: "false",
                          label: LABELS.NO,
                          checked: selectedRow.id
                            ? selectedRow.billStatus === false
                            : false,
                          disabled: false,
                        },
                      ]}
                      row={true}
                      name={"billStatus"}
                    />
                  </div>
                </div>
              </div>
              {/* mandatoryResults */}
              {mandatoryResults.length > 0 && (
                <div className="mandatoryBox">
                  <ul>
                    {mandatoryResults.map((m) => {
                      return (
                        <li>
                          <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              <div className="formGroup submitBtnWrapper">
                <div className="flexbtnjustify">
                  <Btn
                    text={LABELS.CANCEL}
                    bgColor={COLORS.RELOAD_EXPORT}
                    color={COLORS.RELOAD_EXPORT_TEXT}
                    // loading={isSubmit}
                    onClick={() => {
                      setManageDialog(false);
                      setMandatoryResults([]);
                    }}
                  />
                  <Btn
                    text={LABELS.SAVE}
                    loading={isSubmit}
                    onClick={manageRecord}
                    bgColor={COLORS.SAVE_GREEN}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="flexCenter" style={{ height: 500 }}>
              <Loader />
            </div>
          )}
        </UiDialog>
      )}

      {fuelEntryDialog && (
        <FuelForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setFuelEntryDialog(val);
          }}
        />
      )}

      {repairtEntryDialog && (
        <RepairForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setRepairEntryDialog(val);
          }}
        />
      )}

      {paymentEntryDialog && (
        <TripPaymentForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setPaymentEntryDialog(val);
          }}
        />
      )}

      {receiptEntryDialog && (
        <TripReceiptForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setReceiptEntryDialog(val);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default withSnackbar(BillStatus);
